import { useNavigate } from "react-router-dom";
import { ReactComponent as StartWithPraxisPlayIcon } from "../../../assets/icons/start-with-praxisplay.svg";
import { Button } from "../../../components/Button";

export function StartWithPraxisplayPopup({
    onExploreBadgeCenter,
}: {
    onExploreBadgeCenter: () => void;
}) {
    const navigate = useNavigate();
    const handleGoToPraxisPlay = () => {
        navigate("/praxisplay/role-play");
    }

    return (
        <div className="absolute top-0 left-0 w-full h-full rounded-[12px] flex items-center justify-center" style={{
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.50)"
        }}>
            <div className="bg-background2 w-[550px] h-[415px] shadow-[0_2px_4px_-2px_rgba(0,0,0,0.50),0_4px_6px_-1px_rgba(0,0,0,0.10)] rounded-[12px] p-10 flex flex-col gap-4 items-center justify-center">
                <StartWithPraxisPlayIcon />
                <div className="flex flex-col gap-2 items-center justify-center">
                    <span className="text-xl font-semibold text-black">Start with PraxisPlay</span>
                    <span className="text-base text-black">Complete 1 Game Mode session to unlock the Badge Center.</span>
                </div>
                <div className="flex flex-col gap-2 items-center justify-center">
                    <Button variant="primary" className="!h-10 w-[215px] !rounded-full" onClick={handleGoToPraxisPlay}>Go to PraxisPlay</Button>
                    <Button variant="outline" className="!h-10 w-[215px] !rounded-full" onClick={onExploreBadgeCenter}>Explore Badge Center</Button>
                </div>
            </div>
        </div>
    )
}